import React from "react";
import "./Page404.css";

export default function Page404() {
  return (
    <div className="wrapper404">
      <div className="error404"></div>
      <h1 className="text404">404 - No such page found</h1>
    </div>
  );
}